<template>
  <svg
    v-if="type === 'default'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2806 18.2193C19.3503 18.289 19.4056 18.3717 19.4433 18.4628C19.481 18.5538 19.5004 18.6514 19.5004 18.7499C19.5004 18.8485 19.481 18.9461 19.4433 19.0371C19.4056 19.1281 19.3503 19.2109 19.2806 19.2806C19.2109 19.3502 19.1282 19.4055 19.0372 19.4432C18.9461 19.4809 18.8485 19.5003 18.75 19.5003C18.6514 19.5003 18.5539 19.4809 18.4628 19.4432C18.3718 19.4055 18.289 19.3502 18.2194 19.2806L12 13.0602L5.78061 19.2806C5.63988 19.4213 5.44901 19.5003 5.24999 19.5003C5.05097 19.5003 4.8601 19.4213 4.71936 19.2806C4.57863 19.1398 4.49957 18.949 4.49957 18.7499C4.49957 18.5509 4.57863 18.36 4.71936 18.2193L10.9397 11.9999L4.71936 5.78055C4.57863 5.63982 4.49957 5.44895 4.49957 5.24993C4.49957 5.05091 4.57863 4.86003 4.71936 4.7193C4.8601 4.57857 5.05097 4.49951 5.24999 4.49951C5.44901 4.49951 5.63988 4.57857 5.78061 4.7193L12 10.9396L18.2194 4.7193C18.3601 4.57857 18.551 4.49951 18.75 4.49951C18.949 4.49951 19.1399 4.57857 19.2806 4.7193C19.4213 4.86003 19.5004 5.05091 19.5004 5.24993C19.5004 5.44895 19.4213 5.63982 19.2806 5.78055L13.0603 11.9999L19.2806 18.2193Z"
      :fill="fill"
    />
  </svg>
  
  <svg
    v-else-if="type === 'circle'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.7656 9.36629L13.1309 12L15.7656 14.6337C15.8399 14.708 15.8989 14.7963 15.9391 14.8934C15.9793 14.9905 16 15.0945 16 15.1996C16 15.3047 15.9793 15.4088 15.9391 15.5059C15.8989 15.603 15.8399 15.6913 15.7656 15.7656C15.6913 15.8399 15.603 15.8989 15.5059 15.9391C15.4088 15.9793 15.3047 16 15.1996 16C15.0945 16 14.9905 15.9793 14.8934 15.9391C14.7963 15.8989 14.708 15.8399 14.6337 15.7656L12 13.1309L9.36629 15.7656C9.29197 15.8399 9.20374 15.8989 9.10664 15.9391C9.00954 15.9793 8.90546 16 8.80036 16C8.69525 16 8.59118 15.9793 8.49407 15.9391C8.39697 15.8989 8.30874 15.8399 8.23442 15.7656C8.1601 15.6913 8.10114 15.603 8.06092 15.5059C8.0207 15.4088 8 15.3047 8 15.1996C8 15.0945 8.0207 14.9905 8.06092 14.8934C8.10114 14.7963 8.1601 14.708 8.23442 14.6337L10.8691 12L8.23442 9.36629C8.08432 9.2162 8 9.01262 8 8.80036C8 8.58809 8.08432 8.38451 8.23442 8.23442C8.38451 8.08432 8.58809 8 8.80036 8C9.01262 8 9.2162 8.08432 9.36629 8.23442L12 10.8691L14.6337 8.23442C14.708 8.1601 14.7963 8.10114 14.8934 8.06092C14.9905 8.0207 15.0945 8 15.1996 8C15.3047 8 15.4088 8.0207 15.5059 8.06092C15.603 8.10114 15.6913 8.1601 15.7656 8.23442C15.8399 8.30874 15.8989 8.39697 15.9391 8.49407C15.9793 8.59118 16 8.69525 16 8.80036C16 8.90546 15.9793 9.00953 15.9391 9.10664C15.8989 9.20374 15.8399 9.29197 15.7656 9.36629Z"
      :fill="fill"
    />
  </svg>

</template>

<script setup>
defineOptions({
  name: 'V2IconsClose'
})

defineProps({
  type: {
    type: String,
    default: 'default',
    validator: value => ['default', 'circle'].includes(value)
  },

  fill: {
    type: String,
    default: '#361564'
  }
})
</script>
